import { FC, useReducer } from 'react';

import { Settings } from 'lucide-react';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { BroadcastFormDialog } from '../../broadcastFormDialog/BroadcastFormDialog';

import { BroadcastNotification } from 'v2/types/BroadcastNotificationModel';

interface EditNotificationColumnProps {
  item: BroadcastNotification;
  onRevalidate: VoidFunction;
}

export const EditNotificationColumn: FC<EditNotificationColumnProps> = ({ item, onRevalidate }) => {
  const [isOpen, toggleOpen] = useReducer((s) => !s, false);

  const handleSuccess = () => {
    onRevalidate();
    toggleOpen();
  };

  return (
    <>
      <Tooltip title="Edit" placement="top">
        <IconButton color="warning" size="small" onClick={toggleOpen}>
          <Settings size={18} />
        </IconButton>
      </Tooltip>

      <BroadcastFormDialog isOpen={isOpen} onClose={toggleOpen} notification={item} onSuccess={handleSuccess} />
    </>
  );
};
